<template>
  <div class="h5-checkout-detail">
    <div class="h5-checkout-detail__header">
      Total Amount
      <IntlCurrency
        class="h5-checkout-detail__currency"
        currency="USD"
      />
      <span class="h5-checkout-detail__amount">{{ totalAmountAfterDiscount }}</span>
      <Icon
        class="h5-checkout-detail__arrow"
        name="arrow-up-l-2"
        @click="$emit('close')"
      />
    </div>
    <div class="h5-checkout-detail__products">
      <div
        class="h5-checkout-detail-product"
        v-for="sku of selectedSkuList"
        :key="sku.skuId"
      >
        <Image
          class="h5-checkout-detail-product__image"
          :src="sku.skuImageUrl"
        />
        <p class="h5-checkout-detail-product__title">
          <span>
            {{ currency.current.targetUnit }}{{ productPrice(sku.price) }}
          </span>
          × {{ sku.quantity }}
        </p>
      </div>
    </div>
    <div class="h5-checkout-detail__content">
      <div class="h5-checkout-detail__title">
        <div class="h5-checkout-detail__dot" />
        Summary
      </div>
      <div class="h5-checkout-detail__summary">
        <OrderSummary />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { Image } from '@/components/Image'
import { IntlCurrency } from '@/components/NewIntlCurrency'
import OrderSummary from '../../components/OrderSummary.vue'
import { useCurrencyStore } from '@/pinia/currency'
import { useOrder } from '@/views/Carts/hooks/useOrder'
import { bankersRoundWithMax } from '@/utils/utils'

defineEmits(['close'])

const currency = useCurrencyStore()

const { selectedSkuList, totalAmountAfterDiscount } = useOrder()

const productPrice = (price) => {
  return bankersRoundWithMax(price * currency.current.rate, 0.01)
}
</script>

<style lang="less" scoped>
.h5-checkout-detail {
  &__header {
    display: flex;
    align-items: center;
    font-family: mon-600;
    font-size: 14px;
    line-height: 18px;
  }

  &__currency {
    margin-left: auto;
    font-size: 18px;
  }

  &__amount {
    font-family: mon-700;
    font-size: 18px;
    line-height: 22px;
  }

  &__arrow {
    margin-left: 4px;
    font-size: 16px;
  }

  &__products {
    display: flex;
    gap: 12px;
    margin: 0 -12px;
    padding: 20px 12px;
    overflow-x: auto;
  }

  &-product {
    flex-shrink: 0;

    &__image {
      display: block;
      width: 64px;
      aspect-ratio: 1;
      border-radius: 4px;
    }

    &__title {
      margin-top: 8px;
      font-family: mon-500;
      font-size: 10px;
      line-height: 14px;

      > span {
        font-family: mon-600;
      }
    }
  }

  &__content {
    border-top: 1px solid #232323;
    padding: 20px 0;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: mon-600;
    font-size: 14px;
    line-height: 18px;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #B2B7C2;
  }

  &__summary {
    margin-left: 16px;
    margin-top: 12px;
    padding: 16px 12px;
    background-color: #242424;
    border-radius: 8px;

    :deep(.h5-order-summary__divider) {
      background-color: #494D51;
    }

    :deep(.h5-order-summary-cell__amount) {
      color: #FFFFFF;
    }
  }
}
</style>
